import { hash } from '@ember/helper';
import { action } from '@ember/object';
import type { WithBoundArgs } from '@glint/template';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralDropdownsOtaDropdown from 'lumen/components/general/dropdowns/ota-dropdown';
import SettingsCurrencyConversionCurrencyPickerGroup from 'lumen/components/settings/currency-conversion/currency-picker/group';
import SettingsCurrencyConversionCurrencyPickerItem from 'lumen/components/settings/currency-conversion/currency-picker/item';

interface SettingsCurrencyConversionCurrencyPickerMenuSignature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
    setIsOpen: (isOpen: boolean) => void;
  };
  Blocks: {
    default: [
      {
        group: WithBoundArgs<
          typeof SettingsCurrencyConversionCurrencyPickerGroup,
          never
        >;
        item: WithBoundArgs<
          typeof SettingsCurrencyConversionCurrencyPickerItem,
          'dropdown'
        >;
      },
    ];
    footer: [
      {
        dropdown: { toggleDropdown: () => void };
        item: WithBoundArgs<
          typeof SettingsCurrencyConversionCurrencyPickerItem,
          'dropdown'
        >;
      },
    ];
    header: [];
  };
  Element: HTMLDivElement;
}

// @ts-expect-error: Incorrect type
export default class SettingsCurrencyConversionCurrencyPickerMenu extends GeneralDropdownsOtaDropdown<SettingsCurrencyConversionCurrencyPickerMenuSignature> {
  // `dropdownClass` is used by OTA dropdown for the outside click detection (see ota-dropdown component)
  dropdownClass = '.dropdown-target';
  dropdownControls = {
    toggleDropdown: (): void => this.toggleDropdown(),
  };

  @action
  toggleDropdown(): void {
    // Keep internal state aligned with the external arg before toggling.
    // This prevents a stale internal value from flipping the UI in the wrong direction.
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.args.isOpen !== this.isOpen) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      this.isOpen = this.args.isOpen;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    super.toggleDropdown();
    // Notify the parent of the new open state after toggling, so they can react accordingly (e.g. when the menu trigger button is clicked).
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.setIsOpen(this.isOpen);

    // @ts-expect-error: Incorrect type
    if (!this.isOpen) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.onClose();
    }
  }

  <template>
    <div class="dropdown">
      <PrismButton
        @buttonType="secondary"
        @iconBefore="currency"
        @label={{t "settings.currency_conversion.select_currencies"}}
        @onClick={{this.toggleDropdown}}
      />
    </div>
    {{#if @isOpen}}
      <div class="dropdown-target rounded-dropdown w-max">
        <div class="flex flex-col leading-normal" ...attributes>
          {{#if (has-block "header")}}
            <div class="border-neutral-default border-b border-solid p-200">
              {{yield to="header"}}
            </div>
          {{/if}}

          <div class="flex-1 overflow-y-auto">
            {{yield
              (hash
                group=(component SettingsCurrencyConversionCurrencyPickerGroup)
                item=(component
                  SettingsCurrencyConversionCurrencyPickerItem
                  dropdown=this.dropdownControls
                )
              )
            }}
          </div>

          <div class="border-neutral-default border-t border-solid">
            {{yield
              (hash
                dropdown=this.dropdownControls
                item=(component
                  SettingsCurrencyConversionCurrencyPickerItem
                  dropdown=this.dropdownControls
                )
              )
              to="footer"
            }}
          </div>
        </div>
      </div>
    {{/if}}
  </template>
}
